export default {
	vendors: [],
	preferredVendors: []
};
